export default "__VITE_ASSET__2c3f4d43__"